import React from 'react';
import PropTypes from 'prop-types';

export default class Regions extends React.PureComponent {

    static propTypes = {
        className: PropTypes.string,
        regions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        length: PropTypes.number
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        if (!this.props.regions) {
            return null;
        }
        let regions = Array.isArray(this.props.regions) ? this.props.regions : Object.values(this.props.regions);
        if (regions.length === 0) {
            return null;
        }
        regions = regions.join(', ');
        if (this.props.length && regions.length+3 > this.props.length) {
            regions = regions.substring(0,(this.props.length + 1))+"...";
        }
        return (
            <span>
                <i className = {this.props.className}/>
                {regions}
            </span>
        );
    }
}